var $ = global.jQuery = global.$;
var _Base = require('./_Base');

/**
 * Track CSS properties
 * @class
 * @extends _Base
 */
var ScrollAnchor = _Base.extend(
  /** @lends ScrollAnchor.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;

    this.link = this.$el.get(0);

    if (this.link && location.pathname.replace(/^\//,'') === this.link.pathname.replace(/^\//,'') && location.hostname === this.link.hostname && this.link.hash) {
      this.target = $(this.link.hash);
      this.target = this.target.length ? this.target : $('[name=' + this.link.hash.slice(1) +']');
      this.id = this.target.attr('id');
      this.$el.on('click', this.scrollToHash.bind(this));
      this.$el.on('click', function(event) {
        $('[data-widget=ScrollAnchor]').removeClass('is-active');
        $(this).addClass('is-active');
      });
    }

  },
  scrollToHash: function(event) {
    var self = this;
    this.target.removeAttr('id');
    this.target.velocity('scroll', {
      duration: 600,
      complete: function() {
        self.target.attr('id',self.id);
      }
    });
  }
});

module.exports = ScrollAnchor;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/ScrollAnchor.js
// module id = 303
// module chunks = 0